module.exports = __webpack_public_path__ + "img/8.8a15b914.png";